/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteVodGate.defs.js";
export { main as default } from "./deleteVodGate.defs.js";
